(() => {
  function imageSrc(image) {
    return image.currentSrc || image.src || image.getAttribute("src");
  }

  function showInMain(gallery, thumb) {
    const mainWrap = gallery.querySelector(".product-main-hover-wrap");
    const mainImage = mainWrap && mainWrap.querySelector(".product-primary-image");
    if (!mainImage || !thumb) return;

    const src = imageSrc(thumb);
    if (!src) return;

    mainImage.src = src;
    mainImage.removeAttribute("srcset");
    mainImage.removeAttribute("sizes");
    mainImage.alt = thumb.alt || mainImage.alt;

    const hoverImage = mainWrap.querySelector(".product-main-hover-image");
    if (hoverImage) {
      hoverImage.src = src;
      hoverImage.removeAttribute("srcset");
      hoverImage.removeAttribute("sizes");
      hoverImage.alt = thumb.alt || hoverImage.alt;
    }

    gallery.querySelectorAll(".gallery-thumb-active").forEach((item) => item.classList.remove("gallery-thumb-active"));
    thumb.classList.add("gallery-thumb-active");
    mainWrap.classList.add("gallery-image-selected");
  }

  function setupGallery(gallery) {
    if (!gallery || gallery.dataset.gallerySwitcherReady === "true") return;
    gallery.dataset.gallerySwitcherReady = "true";

    const thumbnails = gallery.querySelectorAll(".scene-gallery img, .product-gallery > img:not(.product-primary-image):not(.product-hover-image)");
    thumbnails.forEach((thumb) => {
      thumb.classList.add("gallery-thumb");
      thumb.setAttribute("role", "button");
      thumb.setAttribute("tabindex", "0");
      thumb.setAttribute("aria-label", "Show this image larger");
      thumb.addEventListener("click", () => showInMain(gallery, thumb));
      thumb.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          showInMain(gallery, thumb);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(".product-gallery").forEach(setupGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
